<template>
  <SearchTable
    ref="table"
    :header="{
      title: 'Ponude',
      icon: 'sticky_note_2',
      class: 'md-card-header-brand',
    }"
    :queriedData="offers"
    :metaData="metaData"
    :getItems="getOfferLogs"
    :openItem="openOfferLog"
    :params="params"
    :sortBy="'id'"
    :individualFunction="[
      {
        icon: 'print',
        class: 'md-primary md-simple',
        function: getOfferLogPdf,
      },
    ]"
  />
</template>

<script>
import services from '@/api/services';
import api from '@/api/api.js';
import Swal from 'sweetalert2';
import SearchTable from '@/components/SearchTable.vue';
import { openPdfInNewTab } from '../utils/helpers';
export default {
  components: {
    SearchTable,
  },
  data() {
    return {
      params: {
        id: '',
        clientName: '',
        totalPrice: [null, null],
        showTotal: ['1', '0'],
        offerIds: '',
      },
      metaData: null,
      offers: [],
    };
  },
  methods: {
    getOfferLogs(printTable = false) {
      const offset = this.metaData ? this.$refs.table.from : 0;
      const limit = this.metaData ? this.$refs.table.pagination.perPage : 75;
      const sortBy = this.metaData ? this.$refs.table.currentSort : null;
      const sortOrder = this.metaData
        ? this.$refs.table.currentSortOrder
        : null;
      api
        .get(services.offers.getOfferLogs, {
          getOfferLogs: true,
          params: this.params,
          offset,
          limit,
          sortBy,
          sortOrder,
          printTable,
        })
        .then(data => {
          this.offers = data.data;
          this.metaData = data.metaData;
        })
        .catch(error => {
          this.alertError(error);
        });
    },
    openOfferLog(item) {
      const ids = item.offerIds.split(', ');
      return Swal.fire({
        text: `Da li želite da otvorite kalkulacije ${item.offerIds}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-info btn-fill',
        cancelButtonClass: 'md-button btn-fill',
        confirmButtonText: 'Otvori',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then(data => {
        if (data.value) {
          const routeData = this.$router.resolve({
            path: '/files',
            query: { paramId: ids.join('|') },
          });
          window.open(routeData.href, '_blank');
        }
      });
    },
    getOfferLogPdf(item) {
      const id = item.id;

      api
        .get(services.offers.getOfferLogPdf, {
          id,
        })
        .then(openPdfInNewTab);
    },
  },
  mounted() {
    this.getOfferLogs();
  },
};
</script>
